module.exports = __webpack_public_path__ + "static/media/battery.15cf5a03.jpg";